module.exports = __webpack_public_path__ + "img/uploading-file-spinner.a10aed66.gif";